import { Box } from '@material-ui/core';
import styles from '../index.module.scss';
import itemIcon from 'assets/img/homepage-stylist/item-icon.png';
import styleIcon from 'assets/img/homepage-stylist/style-icon.png';
import questionIcon from 'assets/img/homepage-stylist/question-icon.png';
import checkIcon from 'assets/svg/review_icon.svg';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { STRINGS } from '../../../../constants';

export const CreateSection = () => {
    const history = useHistory();

    const handleClickAction = (path) => {
        history.push(path);
    };

    const userData = useSelector((state: RootState) => state.userDetail.me);

    return (
        <Box className={styles.sectionContainer} style={{ marginRight: 0 }}>
            <Box className={styles.sectionTitle} style={{ alignSelf: 'center', textAlign: 'center' }}>
                Welcome {userData.firstName} !
            </Box>
            <Box display={'flex'} flexDirection={'row'} overflow={'auto'}>
                <Box
                    className={styles.actionContainer}
                    onClick={() => {
                        handleClickAction(PATH.CREATE_ITEM);
                    }}
                >
                    <img alt="section-icon" className={styles.actionIcon} src={itemIcon}></img>
                    <Box className={styles.actionText}>Add an item</Box>
                </Box>
                <Box
                    className={styles.actionContainer}
                    onClick={() => {
                        handleClickAction(PATH.CREATE_STYLE_CANVAS);
                    }}
                >
                    <img alt="section-icon" className={styles.actionIcon} src={styleIcon}></img>
                    <Box className={styles.actionText}>Create a style</Box>
                </Box>
                {userData.isReviewer && (
                    <Box
                        className={styles.actionContainer}
                        onClick={() => {
                            handleClickAction(PATH.STYLE_REVIEW);
                        }}
                    >
                        <img alt="section-icon" className={styles.actionIcon} src={checkIcon}></img>
                        <Box className={styles.actionText}>{STRINGS.REVIEW_A_STYLE}</Box>
                    </Box>
                )}
                <Box
                    className={styles.actionContainer}
                    onClick={() => {
                        handleClickAction(PATH.STYLE_SUGGESTIONS);
                    }}
                    style={{
                        backgroundColor: '#F5DFCE',
                    }}
                >
                    <img alt="section-icon" className={styles.actionIcon} src={questionIcon}></img>
                    <Box className={styles.actionText}>Not sure what to create?</Box>
                </Box>
            </Box>
        </Box>
    );
};
